/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import plusIcon from 'assets/plus.svg';
import minusIcon from 'assets/minus.svg';

import { sumAndSubstract } from 'utils/numbers';

import styles from './quantityModifier.module.scss';

const QuantityModifierAux = ({
    price,
    product,
    state,
    setState,
    quantityKey,
    shouldRemoveEmpty = false,
}) => {
    const [displayValues, setDisplayValues] = useState({});

    const modifyProducts = (id, quantity, product) => {
        id = Number(id);

        if (quantity === '' || quantity === '.') {
            const copyArray = [...state.products];
            if (copyArray.find((product) => product.id === id)) {
                copyArray.find((product) => product.id === id)[quantityKey] = 0;
                copyArray.find((product) => product.id === id)['confirmedQuantity'] = null;
                copyArray.find((product) => product.id === id)['requestedQuantity'] = 0;
            }
            setState({ ...state, products: copyArray });
            return;
        }

        const numericQuantity = parseFloat(quantity);
        if (isNaN(numericQuantity)) return;

        const copyArray = [...state.products];

        if (copyArray.find((product) => product.id === id)) {
            copyArray.find((product) => product.id === id)[quantityKey] = numericQuantity;
            copyArray.find((product) => product.id === id)['confirmedQuantity'] = null;
            copyArray.find((product) => product.id === id)['requestedQuantity'] = numericQuantity;
        } else {
            if (numericQuantity > 0) {
                const newProduct = { ...product, [quantityKey]: numericQuantity };
                copyArray.push(newProduct);
            }
        }
        setState({ ...state, products: copyArray });
    };

    const handleInputChange = (id, rawValue, product) => {
        const sanitized = rawValue.replace(/[^0-9.]/g, '');
        if ((sanitized.match(/\./g) || []).length > 1) return;

        setDisplayValues(prev => ({ ...prev, [id]: sanitized }));

        if (sanitized === '' || sanitized === '.') {
            modifyProducts(id, '', product);
        } else {
            modifyProducts(id, sanitized, product);
        }
    };

    const handleBlur = (id, quantity) => {
        id = Number(id);

        let cleanValue = typeof quantity === 'string' ? quantity.trim() : String(quantity);
        cleanValue = cleanValue.replace(/[^0-9.]/g, '');

        const parts = cleanValue.split('.');
        if (parts.length > 2) {
            cleanValue = parts[0] + '.' + parts.slice(1).join('');
        }

        const numericValue = parseFloat(cleanValue);
        const copyArray = [...state.products];
        const productIndex = copyArray.findIndex((product) => product.id === id);

        if (productIndex !== -1) {
            if (cleanValue === '' || isNaN(numericValue)) {
                copyArray[productIndex][quantityKey] = 0;
                setDisplayValues(prev => ({ ...prev, [id]: '0' }));
                if (shouldRemoveEmpty) {
                    copyArray.splice(productIndex, 1);
                }
            } else {
                copyArray[productIndex][quantityKey] = numericValue;
                setDisplayValues(prev => ({ ...prev, [id]: String(numericValue) }));
            }
            setState({ ...state, products: copyArray });
        }
    };

    const modifyAmount = (operation, id, product) => {
        const currentDisplay = displayValues[id] !== undefined ? displayValues[id] : String(getInitialInputValue(id));
        const cleanValue = currentDisplay.replace(/,/g, '.');
        let parsedValue = Number(cleanValue);

        if (operation === 'plus') {
            const newValue = sumAndSubstract(parsedValue + 1);
            setDisplayValues(prev => ({ ...prev, [id]: String(newValue) }));
            modifyProducts(id, newValue, product);
        }

        if (operation === 'minus') {
            if (parsedValue > 1) {
                const newValue = sumAndSubstract(parsedValue - 1);
                setDisplayValues(prev => ({ ...prev, [id]: String(newValue) }));
                modifyProducts(id, newValue, product);
            } else {
                setDisplayValues(prev => ({ ...prev, [id]: '0' }));
                handleBlur(id, 0);
            }
        }
    };

    const getInitialInputValue = (id) => {
        for (let i = 0; i < state.products.length; i++) {
            if (state.products[i].id === id) {
                return state.products[i][quantityKey];
            }
        }
        return '';
    };

    const isProductInCart = (id) => {
        for (let i = 0; i < state.products.length; i++) {
            if (state.products[i].id === id) {
                return true;
            }
        }
        return false;
    };







    return (
        <div className={price != false ? styles.quantityContainer : styles.quantityContainerPriceN}>
            <div className={styles.inputContainer}>
                <input
                    className={styles.input}
                    name={product.id}
                    type="text"
                    inputMode="decimal"
                    value={displayValues[product.id] !== undefined ? displayValues[product.id] : String(getInitialInputValue(product.id))}
                    onChange={(e) => handleInputChange(e.target.name, e.target.value, product)}
                    onBlur={(e) =>
                        setTimeout(() => {
                            handleBlur(e.target.name, e.target.value, product);
                        }, 250)
                    }
                    disabled={!isProductInCart(product.id)}
                />
                {isProductInCart(product.id) && <span>{product.measurementUnit}</span>}
            </div>
        </div>
    );
};

QuantityModifierAux.propTypes = {
    product: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    setState: PropTypes.func.isRequired,
    quantityKey: PropTypes.string.isRequired,
    shouldRemoveEmpty: PropTypes.bool,
};

export default QuantityModifierAux;
